module.exports = __webpack_public_path__ + "Fonts/active-vertical-toggle-icon.svg";